var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 44.5C13.25 27.2411 27.2411 13.25 44.5 13.25C61.7587 13.25 75.75 27.2411 75.75 44.5C75.75 61.7587 61.7587 75.75 44.5 75.75C27.2411 75.75 13.25 61.7587 13.25 44.5ZM44.5 0.75C20.3376 0.75 0.75 20.3376 0.75 44.5C0.75 68.6625 20.3376 88.25 44.5 88.25C54.3269 88.25 63.3975 85.01 70.7012 79.54L102.581 111.419C105.021 113.86 108.979 113.86 111.419 111.419C113.86 108.979 113.86 105.021 111.419 102.581L79.54 70.7012C85.01 63.3975 88.25 54.3269 88.25 44.5C88.25 20.3376 68.6625 0.75 44.5 0.75Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogSearch);
export default __webpack_public_path__ + "static/media/catalog-search.1a9573de0c0c5dc7c6de3b7e439f8dd0.svg";
export { ForwardRef as ReactComponent };